import HttpService from './httpService';
import config from '../../config';

class FuncionalidadesApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async cargarFuncionalidades({ headquarter }) {
    return this.get('cargarFuncionalidades', { params: { headquarter } });
  }

  async guardarFuncionalidades({ data }) {
    return this.post('guardarFuncionalidades', { params: { data } });
  }

  async obtenerLmsActivo() {
    return this.get('lmsActivo');
  }

  // Devuelve la pasarela de pago activa. Hoy el backend la sirve dentro
  // de cargarFuncionalidades. El campo concreto puede variar; mantenemos
  // este wrapper para aislar al resto del front del detalle.
  async obtenerPasarelaActiva({ headquarter }) {
    return this.get('pasarelaActiva', { params: { headquarter }, silent: true });
  }
}

const funcionalidadesApiService = new FuncionalidadesApiService(config.REACT_APP_NODE_API);
export default funcionalidadesApiService;
